export function normalizeText(text: string): string {
  text = text.replace(/\n/g, ' ')
  text = text.replace(/[ ]+/g, ' ')
  return text.trim()
}
